import React, { useState, useEffect } from 'react';
import { Widget, GridView, SimpleView, Table } from '@digital/ui';
import PerfectScrollbar from 'react-perfect-scrollbar';

const Aprovador = () => {

    useEffect(() => {

    }, []);

    return (
        <SimpleView>
            <GridView noform>
                <Widget title="Relatório de Envio pendência do Aprovador">
                    <PerfectScrollbar>
                        <Table columns={[]} dataSource={[]} pagination={{pageSize: 100}} />
                    </PerfectScrollbar>
                </Widget>
            </GridView>
        </SimpleView>
    );
};

export default Aprovador;
